module.exports = __webpack_public_path__ + "img/haha.f12c7d06.png";